import { WeekdayWeekHeatmapChart, WeekdayWeekHeatmapChartProps } from '../../../renderers/weekday-week-heatmap-chart/weekday-week-heatmap-chart.component';
import { VENDING_PACKAGE_VOLUME_WEEKDAY_HEATMAP_CHART_DEFINITION } from './vending-package-volume-weekday-heatmap-chart.definition';
import { VENDING_PACKAGE_VOLUME_WEEKDAY_HEATMAP_CHART_MOCK_DATA } from './vending-package-volume-weekday-heatmap-chart.mock';

export const VendingPackageVolumeWeekdayHeatmapChart = (props: WeekdayWeekHeatmapChartProps) => <WeekdayWeekHeatmapChart {...props} />;

VendingPackageVolumeWeekdayHeatmapChart.definition = VENDING_PACKAGE_VOLUME_WEEKDAY_HEATMAP_CHART_DEFINITION;
VendingPackageVolumeWeekdayHeatmapChart.mockData = VENDING_PACKAGE_VOLUME_WEEKDAY_HEATMAP_CHART_MOCK_DATA;
